import request from '../utils/request'
const {swSewagePath} = window.globalConfig;

export default class ReportApi {
   
    static exportByQuery = (params) => {
        return request.post('/sw-sewage/api/0/report/exportByQuery', params,{
            responseType: 'blob'
        })
    }

    static queryStationDataByType = (params) => {
        return request.post('/sw-sewage/api/0/report/queryStationDataByType', params)
    }

    static totalWater =(params) => {
        return request.post(`/${swSewagePath}/api/dataanalysis/selectWaterYield`,params)
    }

    static InAndOutWater = (params) =>{
        return request.post(`/${swSewagePath}/api/dataanalysis/selectInAndOutWaterYield`,params)
    }

    static selectWaterQuality = (params) =>{
        return request.post(`/${swSewagePath}/api/dataanalysis/selectWaterQuality`,params)
    }
	//药耗量
	static selectYaoSurface = (params) =>{
	    return request.post(`/${swSewagePath}/api/dataanalysis/selectYaoSurface`,params)
	}
    //能耗量
    static selectDnbSurface = (params) =>{
        return request.post(`/${swSewagePath}/api/dataanalysis/selectDnbSurface`,params)
    }
    //总能耗比
    static selectDnbThanSurface = (params) =>{
        return request.post(`/${swSewagePath}/api/dataanalysis/selectDnbThanSurface`,params)
    }
    //能耗比
    static selectDnbThanSurfaceAnalysis = (params) =>{
        return request.post(`/${swSewagePath}/api/dataanalysis/selectDnbThanSurfaceAnalysis`,params)
    }
}
